const productVariantList = document.querySelector('#variant-list-items');
let productVariantListItems = document.querySelectorAll('#variant-list-items li');
let productVariantInventoryData = parseVariantInventoryData();
let remoteVariantInventoryData = [];
const colorSelectorParent = document.querySelector('#color-selector-container');
const selectedText = document.querySelector('#selected-color-name');
const mainProductImage = document.querySelector('.main-product-image');
const viewSwitcher = document.querySelectorAll('.view-switcher .switch');

const viewSection = document.querySelectorAll('.view-section-wrapper .view-section');
const mainCanvasView = document.querySelector('.main-canvas-view');


const allCanvasParents = document.querySelectorAll('.canvas-view');
const uploadInputs = document.querySelectorAll(".file_uploader input[type='file']");
const fabricCanvasMap = {};
// const CLOUDINARY_UPLOAD_ENDPOINT = "https://song-pettus-customiser.vercel.app/api/cloudinary";

const CLOUDINARY_UPLOAD_ENDPOINT = "https://song-pettus-customiser-mu.vercel.app/api/cloudinary";


let canAddToCart = false;
let activeDecorationType = document.querySelector('.decoration-option.is-active')?.dataset.decorationType || 'Print';
const selectedPositionMap = {};
const uploadedArtworkFiles = {};
let stickyButtonText = 'PLEASE SELECT PRINT AREAS';
let stickyButtonDisabled = true;

function initSizeGuideModals() {
  const modalConfigs = [
    {
      triggerSelector: '.prnt-size-guide-btn',
      contentSelector: '.size-guide-content',
      label: 'Print Size Guide'
    },
    {
      triggerSelector: '.shirt-size-guide-btn',
      contentSelector: '.shirt-size-guide-content',
      label: 'Size Chart'
    }
  ];

  const closeModal = (modal, trigger) => {
    if (!modal) return;

    modal.classList.add('hidden');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('size-guide-modal-open');
  };

  const closeAllModals = () => {
    modalConfigs.forEach(({ triggerSelector, contentSelector }) => {
      const trigger = document.querySelector(triggerSelector);
      const modal = document.querySelector(contentSelector);
      closeModal(modal, trigger);
    });
  };

  modalConfigs.forEach(({ triggerSelector, contentSelector, label }) => {
    const trigger = document.querySelector(triggerSelector);
    const modal = document.querySelector(contentSelector);

    if (!trigger || !modal || modal.dataset.sizeGuideModalReady === 'true') return;

    modal.dataset.sizeGuideModalReady = 'true';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-label', label);

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');

    const dialog = document.createElement('div');
    dialog.className = 'size-guide-modal-dialog';

    while (modal.firstChild) {
      dialog.appendChild(modal.firstChild);
    }

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'size-guide-modal-close';
    closeButton.setAttribute('aria-label', `Close ${label}`);
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>
`;

    dialog.prepend(closeButton);
    modal.appendChild(dialog);

    const openModal = () => {
      closeAllModals();
      modal.classList.remove('hidden');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('size-guide-modal-open');
      closeButton.focus();
    };

    trigger.addEventListener('click', openModal);
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      openModal();
    });

    closeButton.addEventListener('click', () => closeModal(modal, trigger));
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal(modal, trigger);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeAllModals();
  });
}

function normalizeBoolean(value) {
  return value === true || value === 'true';
}

function getViewSection(viewName) {
  return document.querySelector(`.print-location-wrapper .view-section[data-view="${viewName}"]`);
}

function getViewFabricCanvas(viewName) {
  return fabricCanvasMap[viewName];
}

function normalizeColorKey(value) {
  return String(value || '')
    .replace(/&amp;/g, '&')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

function toColorHandle(value) {
  return normalizeColorKey(value)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getUtilityColorElement(colorValue, colorKey = '') {
  const normalizedColor = normalizeColorKey(colorValue);
  const normalizedKey = toColorHandle(colorKey || colorValue);
  const colorItems = [...document.querySelectorAll('.utility-color-images span')];

  if (!normalizedColor && !normalizedKey) return colorItems[0] || null;

  return colorItems.find(item => {
    const itemKey = toColorHandle(item.dataset.utilityColorKey || item.dataset.utilityColor);
    const itemColor = normalizeColorKey(item.dataset.utilityColor);

    return (normalizedKey && itemKey === normalizedKey) || (normalizedColor && itemColor === normalizedColor);
  }) || null;
}

// function stripImageQueryString(value) {
//   return String(value || '').split('?')[0];
// }

function stripImageQueryString(value) {
  return String(value || '');
}

function stripImageQueryStringsFromMap(value) {
  if (Array.isArray(value)) return value.map(stripImageQueryStringsFromMap);
  if (!value || typeof value !== 'object') {
    return typeof value === 'string' ? stripImageQueryString(value) : value;
  }

  return Object.entries(value).reduce((cleanedValue, [key, itemValue]) => {
    cleanedValue[key] = stripImageQueryStringsFromMap(itemValue);
    return cleanedValue;
  }, {});
}

function parseUtilityColorImages(colorEl) {
  if (!colorEl) return {};

  try {
    return stripImageQueryStringsFromMap(JSON.parse(colorEl.dataset.utilityImages || '{}'));
  } catch (error) {
    console.warn('Invalid color image JSON', error);
    return {};
  }
}

function getVariantFallbackImages(colorValue, colorKey = '') {
  const normalizedColor = normalizeColorKey(colorValue);
  const normalizedKey = toColorHandle(colorKey || colorValue);
  const fallbackEl = [...document.querySelectorAll('.utility-variant-fallback-images span')].find(item => {
    const itemKey = toColorHandle(item.dataset.fallbackColorKey || item.dataset.fallbackColor);
    const itemColor = normalizeColorKey(item.dataset.fallbackColor);

    return (normalizedKey && itemKey === normalizedKey) || (normalizedColor && itemColor === normalizedColor);
  });

  if (!fallbackEl) return {};

  const frontImage = stripImageQueryString(fallbackEl.dataset.fallbackFront);
  const backImage = stripImageQueryString(fallbackEl.dataset.fallbackBack);
  const images = {};

  document.querySelectorAll('.view-section-wrapper .view-section[data-view]').forEach(section => {
    const viewName = normalizeColorKey(section.dataset.viewName || section.dataset.view);
    if (frontImage && viewName.includes('front')) images[section.dataset.view] = frontImage;
    if (backImage && viewName.includes('back')) images[section.dataset.view] = backImage;
  });

  return images;
}

function getActiveColorImages() {
  const activeColorBtn = document.querySelector('#color-selector-container button.is-active');
  const activeColor = activeColorBtn?.getAttribute('data-button-value');
  const activeColorKey = activeColorBtn?.getAttribute('data-color-key');
  const colorEl = getUtilityColorElement(activeColor, activeColorKey);
  const fallbackImages = getVariantFallbackImages(activeColor, activeColorKey);
  const appImages = parseUtilityColorImages(colorEl);
  const resolvedImages = { ...appImages };

  // Front and Back always come from Shopify product media. Remove both the
  // view-level and position-level app keys for those views, then apply the
  // generated media images. Other views, including Sleeve, stay app-driven.
  document.querySelectorAll('.view-section-wrapper .view-section[data-view]').forEach(section => {
    const viewName = normalizeColorKey(section.dataset.viewName || section.dataset.view);
    if (!viewName.includes('front') && !viewName.includes('back')) return;

    delete resolvedImages[section.dataset.view];
    delete resolvedImages[section.dataset.viewKey];
    section.querySelectorAll('.position-card[data-image-key]').forEach(card => {
      delete resolvedImages[card.dataset.imageKey];
    });

    if (fallbackImages[section.dataset.view]) {
      resolvedImages[section.dataset.view] = fallbackImages[section.dataset.view];
    }
  });

  return resolvedImages;
}

function normalizeShopifyId(value) {
  return String(value || '').split('/').pop().trim();
}

function parseVariantInventoryData() {
  const dataEl = document.getElementById('variant-inventory-data');
  if (!dataEl) return [];

  try {
    const data = JSON.parse(dataEl.textContent || '[]');
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.warn('Invalid variant inventory JSON', error);
    return [];
  }
}

function parseVariantInventoryDataFromDocument(doc) {
  const dataEl = doc?.querySelector?.('#variant-inventory-data');
  if (!dataEl) return [];

  try {
    const data = JSON.parse(dataEl.textContent || '[]');
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.warn('Invalid paginated variant inventory JSON', error);
    return [];
  }
}

function refreshVariantListItems() {
  productVariantListItems = document.querySelectorAll('#variant-list-items li');
}

function appendVariantListItemsFromDocument(doc) {
  if (!productVariantList || !doc) return;

  const existingVariantIds = new Set(
    [...productVariantList.querySelectorAll('li[data-variant-id]')]
      .map(item => String(item.dataset.variantId || ''))
      .filter(Boolean)
  );

  doc.querySelectorAll('#variant-list-items li[data-variant-id]').forEach(item => {
    const variantId = String(item.dataset.variantId || '');
    if (!variantId || existingVariantIds.has(variantId)) return;

    productVariantList.appendChild(item.cloneNode(true));
    existingVariantIds.add(variantId);
  });

  refreshVariantListItems();
}

function mergeVariantInventoryData(records = []) {
  if (!Array.isArray(records) || !records.length) return;

  const existingIds = new Set(productVariantInventoryData.map(record => String(record.id || '')));
  records.forEach(record => {
    const id = String(record.id || '');
    if (!id || existingIds.has(id)) return;

    productVariantInventoryData.push(record);
    existingIds.add(id);
  });
}

async function loadPaginatedVariantListItems() {
  if (!productVariantList) return;

  const sectionId = productVariantList.dataset.sectionId;
  const pages = parseInt(productVariantList.dataset.variantPages || 1, 10) || 1;
  if (!sectionId || pages <= 1) return;

  const baseUrl = new URL(window.location.href);

  for (let page = 2; page <= pages; page += 1) {
    const url = new URL(baseUrl.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));

    try {
      const response = await fetch(url.href, {
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) continue;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      appendVariantListItemsFromDocument(doc);
      mergeVariantInventoryData(parseVariantInventoryDataFromDocument(doc));
    } catch (error) {
      console.warn('Unable to load paginated variants', error);
    }
  }

  updateSizeCards();
}

async function loadRemoteVariantInventoryData() {
  const handle = productVariantList?.dataset.productHandle;
  if (!handle) return;

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}products/${handle}.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return;

    const productJson = await response.json();
    const variants = Array.isArray(productJson?.variants) ? productJson.variants : [];

    remoteVariantInventoryData = variants.map(variant => ({
      id: variant.id,
      price: variant.price,
      inventory: variant.inventory_quantity,
      available: variant.available,
      inventoryManagement: variant.inventory_management,
      inventoryPolicy: variant.inventory_policy,
      option1: variant.option1,
      option2: variant.option2,
      option3: variant.option3,
      title: variant.title
    }));

    updateSizeCards();
  } catch (error) {
    console.warn('Unable to load remote variant inventory', error);
  }
}

function normalizeVariantOptionValue(value) {
  return String(value || '')
    .replace(/&amp;/g, '&')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
}

function getVariantOptionValues(variantEl) {
  return [
    variantEl?.dataset.option1,
    variantEl?.dataset.option2,
    variantEl?.dataset.option3
  ].map(normalizeVariantOptionValue).filter(Boolean);
}

function getVariantTitleParts(variantEl) {
  return (variantEl?.dataset.title || '')
    .split('/')
    .map(normalizeVariantOptionValue)
    .filter(Boolean);
}

function getVariantOptionByConfiguredIndex(variantEl, optionType) {
  const index = parseInt(productVariantList?.dataset[`${optionType}OptionIndex`] || 0, 10);
  if (!index) return '';

  return normalizeVariantOptionValue(variantEl?.dataset[`option${index}`]);
}

function optionValueMatches(value, candidates = []) {
  const normalizedValue = normalizeVariantOptionValue(value);
  const valueHandle = toColorHandle(normalizedValue);

  return candidates.some(candidate => {
    const normalizedCandidate = normalizeVariantOptionValue(candidate);
    return normalizedCandidate === normalizedValue || toColorHandle(normalizedCandidate) === valueHandle;
  });
}

function getActiveColorCandidates(button = document.querySelector('#color-selector-container button.is-active')) {
  if (!button) return [];

  return [
    button.getAttribute('data-button-value'),
    button.getAttribute('data-color-key'),
    button.getAttribute('data-color-label'),
    button.getAttribute('aria-label'),
    button.getAttribute('title')
  ].filter(Boolean);
}

function getVariantInventory(variantEl) {
  return parseInt(variantEl?.dataset.variantInventory || 0, 10) || 0;
}

function getVariantRecordOptionValues(variantRecord) {
  return [
    variantRecord?.option1,
    variantRecord?.option2,
    variantRecord?.option3
  ].map(normalizeVariantOptionValue).filter(Boolean);
}

function getVariantRecordTitleParts(variantRecord) {
  return String(variantRecord?.title || '')
    .split('/')
    .map(normalizeVariantOptionValue)
    .filter(Boolean);
}

function getVariantRecordOptionByConfiguredIndex(variantRecord, optionType) {
  const index = parseInt(productVariantList?.dataset[`${optionType}OptionIndex`] || 0, 10);
  if (!index) return '';

  return normalizeVariantOptionValue(variantRecord?.[`option${index}`]);
}

function findVariantRecordForSelection(cardSize, colorCandidates) {
  return [...remoteVariantInventoryData, ...productVariantInventoryData].find(record => {
    const optionValues = getVariantRecordOptionValues(record);
    const titleParts = getVariantRecordTitleParts(record);
    const variantColor = getVariantRecordOptionByConfiguredIndex(record, 'color');
    const variantSize = getVariantRecordOptionByConfiguredIndex(record, 'size');
    const searchableValues = optionValues.length ? optionValues : titleParts;
    const sizeMatches = cardSize ? (
      optionValueMatches(cardSize, [variantSize]) || optionValueMatches(cardSize, searchableValues)
    ) : true;
    const colorMatches = !colorCandidates.length || colorCandidates.some(candidate => (
      optionValueMatches(candidate, [variantColor]) || optionValueMatches(candidate, optionValues) || optionValueMatches(candidate, titleParts)
    ));

    return sizeMatches && colorMatches;
  });
}

function getResolvedVariantInventory(variantEl, variantRecord, cardSize = '', colorCandidates = []) {
  const recordInventory = parseInt(variantRecord?.inventory || 0, 10) || 0;
  const elementInventory = getVariantInventory(variantEl);
  const inventory = Math.max(recordInventory, elementInventory);
  const isAvailable = String(variantRecord?.available ?? variantEl?.dataset.variantAvailable) === 'true';
  const inventoryPolicy = variantRecord?.inventoryPolicy || variantEl?.dataset.inventoryPolicy || '';
  const isWhite = colorCandidates.some(candidate => optionValueMatches(candidate, ['white']));
  const isKnownWhiteStockSize = optionValueMatches(cardSize, ['s', '4xl']);

  if (inventory <= 0 && isAvailable && inventoryPolicy !== 'continue' && isWhite && isKnownWhiteStockSize) {
    return 100;
  }

  return inventory;
}

function getImageForPosition(card, images = getActiveColorImages()) {
  if (!card) return '';

  const positionImage = images[card.dataset.imageKey];
  return stripImageQueryString(positionImage || images[card.dataset.view] || card.dataset.defaultImage || '');
}

function updateViewImage(viewName, imageUrl) {
  const cleanImageUrl = stripImageQueryString(imageUrl);
  if (!cleanImageUrl) return;

  document.querySelectorAll(`.canvas-view[data-view="${viewName}"] .view-image`).forEach(img => {
    img.src = cleanImageUrl;
  });

  document.querySelectorAll(`.view-switcher .switch[data-view="${viewName}"] .view-image`).forEach(img => {
    img.src = cleanImageUrl;
  });
}

function refreshColorImages(images = getActiveColorImages()) {
  document.querySelectorAll(".canvas-view, .view-switcher .switch").forEach(viewSection => {
    const view = viewSection.dataset.view;
    const section = getViewSection(view);
    const activeCard = section?.querySelector('.position-card.active');
    const defaultCard = section?.querySelector('.position-card');
    const imageSourceCard = activeCard || defaultCard;
    const imageUrl = imageSourceCard ? getImageForPosition(imageSourceCard, images) : images[view];
    if (!imageUrl) return;

    viewSection.querySelectorAll(".view-image").forEach(img => {
      img.src = stripImageQueryString(imageUrl);
    });
  });
}

function getSelectedPositions() {
  return [...document.querySelectorAll('.view-section-wrapper .position-card.active')].map(card => ({
    view: card.dataset.view,
    viewName: card.dataset.viewName || card.dataset.view,
    positionId: card.dataset.positionId,
    positionName: card.dataset.positionName,
    addOnVariantId: normalizeShopifyId(card.dataset.addOn),
    addOnTitle: card.dataset.addOnTitle,
    addOnPrice: card.dataset.addOnPrice
  }));
}

function formatPrintLocation(position) {
  const decoration = activeDecorationType || 'Print';
  const viewName = position.viewName || position.view || '';
  let locationName = position.positionName || '';

  locationName = locationName.replace(new RegExp(`^${viewName}\\s+`, 'i'), '');
  locationName = locationName.replace(/\s+chest$/i, '');
  locationName = locationName.trim().toLowerCase();

  return `${decoration} ${viewName}-${locationName}`;
}

function formatSelectedLocation(position) {
  const viewName = position.viewName || position.view || '';
  const positionName = position.positionName || '';

  return `${viewName}-${positionName}`;
}

function getCanvasTransform(viewName) {
  const canvas = getViewFabricCanvas(viewName);
  const object = canvas?.getObjects().find(obj => obj.type === 'image');

  if (!object) return null;

  return {
    left: Math.round(object.left || 0),
    top: Math.round(object.top || 0),
    scaleX: Number((object.scaleX || 1).toFixed(4)),
    scaleY: Number((object.scaleY || 1).toFixed(4)),
    angle: Number((object.angle || 0).toFixed(2))
  };
}

function getCloudinaryImageUrl(uploadResult) {
  return (
    uploadResult?.imageUrl ||
    uploadResult?.message?.secure_url ||
    uploadResult?.message?.url ||
    uploadResult?.secure_url ||
    uploadResult?.url
  );
}

function getSafeCloudinaryFileName(value) {
  return String(value || '')
    .replace(/\.[^.]+$/, '')
    .replace(/[^a-z0-9-_]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase() || 'artwork';
}

async function uploadImageToCloudinary(fileOrBlob, fileName, fallbackExtension = 'jpg') {
  const formData = new FormData();
  const uploadName = fileOrBlob instanceof File ? fileOrBlob.name : `${fileName}.${fallbackExtension}`;

  formData.append("image", fileOrBlob, uploadName);
  formData.append("fileName", fileName);

  const response = await fetch(CLOUDINARY_UPLOAD_ENDPOINT, {
    method: "POST",
    body: formData,
  });

  const result = await response.json();
  const imageUrl = getCloudinaryImageUrl(result);

  if (!response.ok || !imageUrl) {
    throw new Error(result.error || "Cloudinary upload failed");
  }

  return imageUrl;
}

async function uploadSelectedArtworkFiles(selectedPositions) {
  const selectedViews = [...new Set(
    selectedPositions
      .map(position => position.view)
      .filter(viewName => uploadedArtworkFiles[viewName]?.file)
  )];

  const uploadedEntries = await Promise.all(selectedViews.map(async (viewName) => {
    const artwork = uploadedArtworkFiles[viewName];
    const safeFileName = getSafeCloudinaryFileName(artwork.file.name);
    const uploadName = `uploaded-artwork-${viewName}-${Date.now()}-${safeFileName}`;
    const imageUrl = await uploadImageToCloudinary(artwork.file, uploadName);

    return [viewName, {
      view: viewName,
      fileName: artwork.file.name,
      url: imageUrl
    }];
  }));

  return Object.fromEntries(uploadedEntries);
}

function canvasHasArtwork(viewName) {
  const canvas = getViewFabricCanvas(viewName);
  return !!canvas && canvas.getObjects().some(obj => obj.type === 'image');
}

function getArtworkFitScale(imageWidth, imageHeight, canvasWidth, canvasHeight) {
  if (!imageWidth || !imageHeight || !canvasWidth || !canvasHeight) return 1;

  return Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight);
}

function updateUploadLabel(viewName) {
  const section = getViewSection(viewName);
  const uploader = document.querySelector(`.canvas_file_uploader_wrapper .file_uploader[data-file-view="${viewName}"]`);
  const label = uploader?.querySelector('[data-upload-location-label]');
  const selectedNames = [...section?.querySelectorAll('.position-card.active') || []].map(card => card.dataset.positionName);

  if (label) {
    label.textContent = selectedNames.length ? selectedNames.join(', ') : section?.dataset.viewName || viewName;
  }
}

function resetViewArtwork(viewName) {
  const fabricCanvas = getViewFabricCanvas(viewName);

  if (fabricCanvas) {
    fabricCanvas.clear();
    fabricCanvas.renderAll();
  }

  delete uploadedArtworkFiles[viewName];

  const fileInput = document.querySelector(`.file_uploader[data-file-view="${viewName}"] input[type="file"]`);
  if (fileInput) fileInput.value = '';

  const removeBtn = document.querySelector(`.file_uploader[data-file-view="${viewName}"] .remove-image-btn`);
  removeBtn?.classList.add('hidden');
}

function getCanvasDataFromCard(card) {
  const canvasData = card?.querySelector('.canvas-data');

  return {
    canvasHeight: canvasData?.dataset?.height,
    canvasWidth: canvasData?.dataset?.width,
    canvasLeft: canvasData?.dataset?.left,
    canvasTop: canvasData?.dataset?.top
  };
}

function getResolvedCanvasData(card) {
  const ownCanvasData = getCanvasDataFromCard(card);
  const positionName = (card?.dataset.positionName || '').toLowerCase();
  const section = card?.closest('.view-section');

  if (!section || (!positionName.includes('full') && !positionName.includes('shoulder'))) {
    return ownCanvasData;
  }

  const siblingCards = [...section.querySelectorAll('.position-card')];
  const fullCard = siblingCards.find(item => (item.dataset.positionName || '').toLowerCase().includes('full'));
  const shoulderCard = siblingCards.find(item => (item.dataset.positionName || '').toLowerCase().includes('shoulder'));

  if (!fullCard || !shoulderCard) return ownCanvasData;

  const fullCanvasData = getCanvasDataFromCard(fullCard);
  const shoulderCanvasData = getCanvasDataFromCard(shoulderCard);
  const fullArea = parseFloat(fullCanvasData.canvasWidth || 0) * parseFloat(fullCanvasData.canvasHeight || 0);
  const shoulderArea = parseFloat(shoulderCanvasData.canvasWidth || 0) * parseFloat(shoulderCanvasData.canvasHeight || 0);

  if (fullArea >= shoulderArea) return ownCanvasData;

  if (card === fullCard) return shoulderCanvasData;
  if (card === shoulderCard) return fullCanvasData;

  return ownCanvasData;
}

function setCanvasAreaFromCard(card) {
  if (!card) return;

  const currentView = card.dataset.view;
  updateViewImage(currentView, getImageForPosition(card));

  const {
    canvasHeight,
    canvasWidth,
    canvasLeft,
    canvasTop
  } = getResolvedCanvasData(card);

  selectedPositionMap[currentView] = card.dataset.positionId;
  printDrawArea(currentView, { canvasHeight, canvasWidth, canvasLeft, canvasTop });
  updateUploadLabel(currentView);
}






allCanvasParents.forEach((view) => {
  const viewName = view.dataset.view;
  const canvasEl = view.querySelector(".design-canvas");

  // FIX: Dispose of existing instance if it exists to prevent memory leaks
  if (fabricCanvasMap[viewName]) {
    fabricCanvasMap[viewName].dispose();
  }

  const fabricCanvas = new fabric.Canvas(canvasEl, {
    allowTouchScrolling: true, // Better for Shopify mobile themes
    preserveObjectStacking: true
  });

  fabricCanvasMap[viewName] = fabricCanvas;
});

document.querySelectorAll('.decoration-option').forEach((button) => {
  button.addEventListener('click', () => {
    activeDecorationType = button.dataset.decorationType || button.textContent.trim();

    document.querySelectorAll('.decoration-option').forEach((option) => {
      const isActive = option === button;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateButtonState();
  });
});

function toggleCollapsibleSection(section) {
  if (!section?.classList.contains('is-collapsible')) return;

  const isCollapsed = section.classList.toggle('is-collapsed');
  section.querySelector('.view-toggle')?.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
}

document.querySelectorAll('.view-section.is-collapsible .view-section-header').forEach((header) => {
  header.addEventListener('click', (event) => {
    event.stopPropagation();
    toggleCollapsibleSection(header.closest('.view-section'));
  });
});





if (colorSelectorParent) {

    colorSelectorParent.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button) return;

    const colorValue = button.getAttribute('data-button-value').trim();
    const colorKey = button.getAttribute('data-color-key') || colorValue;
    const colorLabel = button.getAttribute('data-color-label') || colorValue;

    if (selectedText) {
      selectedText.textContent = colorLabel;
    }

    colorSelectorParent.querySelectorAll('button').forEach(btn => {
      btn.classList.remove('is-active');
    });

    button.classList.add('is-active');

    const colorCandidates = getActiveColorCandidates(button);

    const li = [...productVariantListItems].find(el => {
    const optionValues = getVariantOptionValues(el);
    const titleParts = getVariantTitleParts(el);
    const variantColor = getVariantOptionByConfiguredIndex(el, 'color');

    return colorCandidates.some(candidate => (
      optionValueMatches(candidate, [variantColor]) || optionValueMatches(candidate, optionValues) || optionValueMatches(candidate, titleParts)
    ));
  });

  const newImageUrl = button.dataset.variantImage || li?.dataset.variantImage;

  if (newImageUrl) {
    mainProductImage.src = stripImageQueryString(newImageUrl);
  }

  const images = getActiveColorImages();

  refreshColorImages(images);



  updateSizeCards();

});


viewSwitcher.forEach((swt) => {
  swt.addEventListener('click', () => {
    
    viewSwitcher.forEach(s => s.classList.remove('active'));
    swt.classList.add('active');

    if (!mainCanvasView.classList.contains('hidden')) {
      handleCanvasVisibility(swt.dataset.view);
    } else {
      let viewImageSrc = swt?.querySelector('.view-image').src;
      if (viewImageSrc) {
        mainProductImage.src = stripImageQueryString(viewImageSrc);
      }
    }
  });
});


viewSection.forEach((view) => {
  view.addEventListener('click', (e) => {
    
   
    const card = e.target.closest('.position-card');
    const currentSection = e.target.closest('.view-section');
    const currentView = currentSection?.dataset.view;

    if (!currentView || e.target.closest('.view-toggle')) return;
    handleCanvasVisibility(currentView);

    if (!card) return;

    const isActive = card.classList.contains('active');
    const allowMultiple = normalizeBoolean(currentSection.dataset.allowMultiple);
    const previouslyActiveCard = currentSection.querySelector('.position-card.active');

    if (!allowMultiple) {
      card.parentElement.querySelectorAll('.position-card').forEach((el) => {
        if (el !== card) el.classList.remove('active');
      });
    }

    if (isActive) {
      card.classList.remove('active');
      delete selectedPositionMap[currentView];
    } else {
      card.classList.add('active');
      selectedPositionMap[currentView] = card.dataset.positionId;
    }

    if (!allowMultiple && previouslyActiveCard && previouslyActiveCard !== card) {
      resetViewArtwork(currentView);
    }

    updateButtonState();


    //file input visibility handler

    checkFileInputVisibility(currentView);

    if(checkActivePositionCard()){
      mainProductImage.classList.add('hidden');
      mainCanvasView.classList.remove('hidden');
    }else{
      mainProductImage.classList.remove('hidden');
      mainCanvasView.classList.add('hidden');
    }

    if (card.classList.contains('active')) {
      setCanvasAreaFromCard(card);
    }

    removeDrawArea(currentView);


    const value = currentSection.getAttribute('data-view');
    const target = document.querySelector(
      `.view-switcher .switch[data-view="${value}"]`
    );
    if (target) {
      target.click();
    } else {
      viewSwitcher.forEach(s => s.classList.remove('active'));
      handleCanvasVisibility(value);
    }
  });
});


uploadInputs.forEach((fileInput) => {
  fileInput.addEventListener("change", (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const currentView = fileInput.dataset.file;
    const fabricCanvas = fabricCanvasMap[currentView];

    if (!fabricCanvas) return;

    uploadedArtworkFiles[currentView] = { file };

    const reader = new FileReader();

    reader.onload = async function (e) {
      const imageUrl = e.target.result;

      fabric.Image.fromURL(imageUrl, function (img) {
        fabricCanvas.clear();

        const canvasWidth = fabricCanvas.getWidth();
        const canvasHeight = fabricCanvas.getHeight();

        const imageWidth = img.width || 1;
        const imageHeight = img.height || 1;
        const fitScale = getArtworkFitScale(imageWidth, imageHeight, canvasWidth, canvasHeight);

        img.scale(fitScale);

        img.set({
          left: canvasWidth / 2,
          top: canvasHeight / 2,
          originX: "center",
          originY: "center",
          hasControls: false, // Set to true so buttons/handles work
          hasBorders: false,
          selectable: true, 
          evented: false,
          customMinScale: Math.max(fitScale * 0.1, 0.001)
        });

        fabricCanvas.add(img);
        fabricCanvas.setActiveObject(img); 
        fabricCanvas.renderAll();

        const currentUploader = document.querySelector(`.file_uploader[data-file-view="${currentView}"]`);
        if (currentUploader) {
          currentUploader.classList.add('has-uploaded-file');
          const uploadStatus = currentUploader.querySelector('[data-upload-status]');
          if (uploadStatus) uploadStatus.textContent = file.name;
          currentUploader.querySelector('.remove-image-btn').classList.remove('hidden');
        }

        updateButtonState();

        // --- NEW LOGIC TO SHOW CANVAS AUTOMATICALLY ---
        
        // 1. Swap from static product image to canvas view
        mainProductImage.classList.add('hidden');
        mainCanvasView.classList.remove('hidden');

        // 2. Show the specific canvas for the view just uploaded
        handleCanvasVisibility(currentView);

        // 3. Update the view switcher UI to show which view is now active
        viewSwitcher.forEach(s => s.classList.remove('active'));
        const activeSwitch = document.querySelector(`.view-switcher .switch[data-view="${currentView}"]`);
        if (activeSwitch) {
          activeSwitch.classList.add('active');
        }
      });
    };

      reader.readAsDataURL(file);
    });
  });


  document.querySelector('.canvas_file_uploader_wrapper')?.addEventListener('click', (e) => {
  const removeButton = e.target.closest('.remove-image-btn');
  if (removeButton) {
    const container = removeButton.closest('.file_uploader');
    const fileInput = container.querySelector('.file-input');
    const currentView = fileInput.dataset.file;
    const fabricCanvas = fabricCanvasMap[currentView];

    // 1. Clear the specific Fabric Canvas
    if (fabricCanvas) {
      fabricCanvas.clear();
      fabricCanvas.renderAll();
    }

    // 2. Reset the file input so the same image can be re-uploaded if needed
    fileInput.value = "";
    delete uploadedArtworkFiles[currentView];

    // 3. Hide the remove button itself
    removeButton.classList.add('hidden');
    container.classList.remove('has-uploaded-file');
    const uploadStatus = container.querySelector('[data-upload-status]');
    if (uploadStatus) uploadStatus.textContent = "No file uploaded";

    // 4. (Optional) UI Reset: If you want to show the static product image 
    // when a view becomes empty again
    const allCanvasesEmpty = Object.values(fabricCanvasMap).every(canvas => canvas.getObjects().length === 0);
    if (allCanvasesEmpty) {
      mainProductImage.classList.remove('hidden');
      mainCanvasView.classList.add('hidden');
    }

    // Update your overall button states (e.g., disable Add to Cart if images are required)
    updateButtonState();
  }
});


}



function checkActivePositionCard() {
  const activePositionCards =  document.querySelectorAll('.view-section-wrapper .position-card.active');
  return activePositionCards?.length > 0;
}

function updateUploaderHeadingVisibility() {
  document.querySelector('.design-uploader-heading')?.classList.toggle('hidden', !checkActivePositionCard());
}

function handleCanvasVisibility(currentView){
  allCanvasParents.forEach(cnvs => cnvs.classList.add('hidden'));
  document.querySelector(`.canvas-view[data-view="${currentView}"]`)?.classList.remove('hidden');
}


function checkFileInputVisibility(currentView) {
  const section = document.querySelector(
    `.print-location-wrapper .view-section[data-view="${currentView}"]`
  );
  
  const uploader = document.querySelector(
    `.canvas_file_uploader_wrapper .file_uploader[data-file-view="${currentView}"]`
  );


  if (!section || !uploader) return;

  const hasActiveCard = section.querySelector('.position-card.active');
  uploader.classList.toggle('hidden', !hasActiveCard);
  updateUploaderHeadingVisibility();
}


function printDrawArea(currentView, drawArea = {}) {

  if (!checkActivePositionCard()) return;

  const {
    canvasHeight,
    canvasWidth,
    canvasLeft,
    canvasTop
  } = drawArea;

  if (!canvasHeight || !canvasWidth || !canvasLeft || !canvasTop) return;

  const canvasView = document.querySelector(
    `.canvas-view[data-view="${currentView}"]`
  );

  if (!canvasView) return;

  const printBox = canvasView.querySelector('.canvas-data');

  const fabricCanvas = fabricCanvasMap[currentView];

  if (!printBox || !fabricCanvas) return;

  // parent image wrapper
  const imageWrapper = canvasView.querySelector('.img-wpr');

  const wrapperWidth = imageWrapper.offsetWidth;
  const wrapperHeight = imageWrapper.offsetHeight;

  // convert percentage to pixels
  const actualWidth = (wrapperWidth * parseFloat(canvasWidth)) / 100;
  const actualHeight = (wrapperHeight * parseFloat(canvasHeight)) / 100;

  const actualLeft = (wrapperWidth * parseFloat(canvasLeft)) / 100;
  const actualTop = (wrapperHeight * parseFloat(canvasTop)) / 100;

  // yellow print area
  printBox.style.width = `${actualWidth}px`;
  printBox.style.height = `${actualHeight}px`;
  printBox.style.left = `${actualLeft}px`;
  printBox.style.top = `${actualTop}px`;
  printBox.style.display = 'block';
  printBox.style.zIndex = '120';
  printBox.style.pointerEvents = 'none';

  // fabric canvas element
  const canvasEl = fabricCanvas.lowerCanvasEl;
  const upperCanvasEl = fabricCanvas.upperCanvasEl;

  // style both canvases
  [canvasEl, upperCanvasEl].forEach((el) => {

    el.style.position = 'absolute';
    el.style.left = `${actualLeft}px`;
    el.style.top = `${actualTop}px`;
    el.style.width = `${actualWidth - 1}px`;
    el.style.height = `${actualHeight - 1}px`;
    el.style.zIndex = '100';
  });

  // set actual fabric size
  fabricCanvas.setWidth(actualWidth);
  fabricCanvas.setHeight(actualHeight);

  fabricCanvas.renderAll();
}


function removeDrawArea(currentView) {

  const checkActive = document.querySelector(
    `.view-section-wrapper .view-section[data-view="${currentView}"] .position-card.active`
  );

  // if no active position selected
  if (!checkActive) {

    // remove yellow area
    const printBox = document
      .querySelector(`.canvas-view[data-view="${currentView}"]`)
      ?.querySelector('.canvas-data');

    if (printBox) {
      printBox.style.height = '';
      printBox.style.width = '';
      printBox.style.left = '';
      printBox.style.top = '';
      printBox.style.display = '';
      printBox.style.zIndex = '';
    }

    // clear fabric canvas
    const fabricCanvas = fabricCanvasMap[currentView];

    if (fabricCanvas) {
      fabricCanvas.clear();

      // optional: rerender
      fabricCanvas.renderAll();
    }

    // reset file input
    const fileInput = document.querySelector(
      `.file_uploader[data-file-view="${currentView}"] input[type="file"]`
    );

    if (fileInput) {
      fileInput.value = '';
    }

    // hide uploader
    const uploader = document.querySelector(
      `.canvas_file_uploader_wrapper .file_uploader[data-file-view="${currentView}"]`
    );

    if (uploader) {
      uploader.classList.add('hidden');
      uploader.classList.remove('has-uploaded-file');
      const uploadStatus = uploader.querySelector('[data-upload-status]');
      if (uploadStatus) uploadStatus.textContent = "No file uploaded";
    }

    const removeBtn = document.querySelector(
      `.canvas_file_uploader_wrapper .file_uploader[data-file-view="${currentView}"] .remove-image-btn`
    );
    
    if (removeBtn) {
      removeBtn.classList.add('hidden');
    }
  }

  updateUploaderHeadingVisibility();
}


const livePreviewBtn = document.getElementById('live-preview-btn');
const previewContainer = document.getElementById('preview-container');
const overlay = document.getElementById('preview-overlay'); // Get the overlay


livePreviewBtn?.addEventListener('click', async () => {
  // 1. Open the popup immediately and show a loading state
  previewContainer.innerHTML = `
    <div id="preview-loader" style="padding: 60px; text-align: center;">
      <p>Generating...</p>
    </div>
    <div class="preview-grid" style="display: none;"></div>
    <button id="close-preview">Close Preview</button>
  `;
  
  previewContainer.classList.add('is-active');
  overlay.classList.add('is-active');

  // 2. Fetch the data while the user sees the loader
  const views = await getCapturedDesignData();
  
  const grid = previewContainer.querySelector('.preview-grid');
  const loader = previewContainer.querySelector('#preview-loader');

  // 3. Clear loader and populate grid
  if (views.length > 0) {
    views.forEach(view => {
      const wrapper = document.createElement('div');
      wrapper.className = 'preview-item';
      wrapper.innerHTML = `
        <img src="${view.url}" style="width:100%; border:1px solid #ddd; border-radius: 4px;">
      `;
      grid.appendChild(wrapper);
    });
    grid.style.display = 'grid'; // Show the grid now that it's ready
  } else {
    grid.innerHTML = `<div style="padding: 40px; text-align: center;">No designs added.</div>`;
    grid.style.display = 'block';
  }

  // 4. Remove the loader
  loader.remove();
});

// Close Logic
function closePreview() {
  previewContainer.classList.remove('is-active');
  overlay.classList.remove('is-active');
}

// 1. Listen for click on the overlay (to close when clicking outside)
overlay?.addEventListener('click', closePreview);

// 2. Listen for clicks inside the container (to catch the "Close" button)
previewContainer?.addEventListener('click', (e) => {
  if (e.target.id === 'close-preview') {
    closePreview();
  }
});

// Helper to get the fabric instance of the currently visible canvas
function getActiveFabricCanvas() {
  const visibleCanvasView = document.querySelector('.canvas-view:not(.hidden)');
  if (!visibleCanvasView) return null;
  const viewName = visibleCanvasView.dataset.view;
  return fabricCanvasMap[viewName];
}



document.getElementById('print-image-controls')?.addEventListener('click', (e) => {

  const button = e.target.closest('button');
  if (!button) return;

  e.preventDefault();

  const canvas = getActiveFabricCanvas();
  if (!canvas) return;

  const activeObject = canvas.getActiveObject() || canvas.item(0); // Target selected or first object
  if (!activeObject) return;

  const step = 10; // Pixels to move
  const getScaleStep = () => Math.max((activeObject.scaleX || 1) * 0.1, 0.005);

  switch (button.id) {
    // Zoom Controls
    case 'zoom-plus':
      activeObject.scale((activeObject.scaleX || 1) + getScaleStep());
      break;
    case 'zoom-minus':
      activeObject.scale(Math.max(
        activeObject.customMinScale || 0.001,
        (activeObject.scaleX || 1) - getScaleStep()
      ));
      break;

    // Movement Controls
    case 'move-left':
      activeObject.set('left', activeObject.left - step);
      break;
    case 'move-right':
      activeObject.set('left', activeObject.left + step);
      break;
    case 'move-up':
      activeObject.set('top', activeObject.top - step);
      break;
    case 'move-down':
      activeObject.set('top', activeObject.top + step);
      break;
  }

  activeObject.setCoords(); // Update object boundaries
  canvas.requestRenderAll(); // Refresh the canvas
});

function parseMoneyToCents(value) {
  if (!value) return 0;
  const numericValue = Number(String(value).replace(/[^0-9.-]/g, ''));

  if (!Number.isFinite(numericValue)) return 0;
  return Math.round(numericValue * 100);
}

function formatMoneyFromCents(cents) {
  const stickyBar = document.querySelector('[data-sticky-custom-cart-bar]');
  const currencySymbol = stickyBar?.dataset.currencySymbol || '$';

  try {
    const amount = new Intl.NumberFormat(window.Shopify?.locale || undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((cents || 0) / 100);

    return `${currencySymbol}${amount}`;
  } catch (error) {
    return `${currencySymbol}${((cents || 0) / 100).toFixed(2)}`;
  }
}

function getSelectedAddOnUnitPriceCents() {
  return getSelectedPositions().reduce((total, position) => total + parseMoneyToCents(position.addOnPrice), 0);
}

function getDefaultVariantPriceCents() {
  const stickyBar = document.querySelector('[data-sticky-custom-cart-bar]');
  return parseInt(stickyBar?.dataset.defaultVariantPrice || 0, 10) || 0;
}

function getCardVariantPriceCents(card) {
  const cardPrice = card?.dataset.variantPrice;

  if (cardPrice !== undefined && cardPrice !== '') {
    return parseInt(cardPrice, 10) || 0;
  }

  return getDefaultVariantPriceCents();
}

function getCustomiserTotalCents() {
  const addOnUnitPriceCents = getSelectedAddOnUnitPriceCents();

  return [...document.querySelectorAll('.size-card')].reduce((total, card) => {
    const qty = parseInt(card.querySelector('.qty-input')?.value || 0, 10) || 0;
    const variantPriceCents = getCardVariantPriceCents(card);

    return total + (qty * (variantPriceCents + addOnUnitPriceCents));
  }, 0);
}

function getBulkQuantityTotal() {
  return [...document.querySelectorAll('.size-card .qty-input')]
    .reduce((total, input) => total + (parseInt(input.value || 0, 10) || 0), 0);
}

function getMinimumOrderQuantity() {
  const minimumQuantity = parseInt(document.querySelector('[data-min-order-quantity]')?.dataset.minOrderQuantity || '', 10);
  return Number.isFinite(minimumQuantity) && minimumQuantity > 0 ? minimumQuantity : 0;
}

function getMinimumOrderQuantityMessage(minimumQuantity = getMinimumOrderQuantity()) {
  return `Minimum order quantity is ${minimumQuantity}. Please select ${minimumQuantity} or more items.`;
}

function meetsMinimumOrderQuantity(quantity = getBulkQuantityTotal()) {
  const minimumQuantity = getMinimumOrderQuantity();
  return !minimumQuantity || quantity >= minimumQuantity;
}

function getStickyDiscountTiers() {
  return Array.from(document.querySelectorAll('.tier-mark'))
    .map(mark => {
      const limit = parseInt(mark.dataset.limit, 10);
      const discountText = mark.dataset.discount || mark.querySelector('span')?.textContent || '';
      const discount = parseFloat(discountText.replace(/[^\d.]/g, ''));
      return { limit, discount };
    })
    .filter(tier => Number.isFinite(tier.limit) && tier.limit > 0 && Number.isFinite(tier.discount) && tier.discount > 0)
    .sort((a, b) => a.limit - b.limit);
}

function getActiveStickyDiscountTier(quantity = getBulkQuantityTotal()) {
  return getStickyDiscountTiers().reverse().find(tier => quantity >= tier.limit);
}

function renderStickyTotalPrice(priceEl) {
  const subtotalCents = getCustomiserTotalCents();
  const activeDiscountTier = getActiveStickyDiscountTier();
  const eachPriceEl = document.querySelector('[data-sticky-each-price]');
  let displayedTotalCents = subtotalCents;

  if (activeDiscountTier && subtotalCents > 0) {
    const discountedCents = Math.round(subtotalCents * ((100 - activeDiscountTier.discount) / 100));
    displayedTotalCents = discountedCents;
    priceEl.innerHTML = `
      <span class="custom-sticky-cart-bar__price-original">${formatMoneyFromCents(subtotalCents)}</span>
      <span class="custom-sticky-cart-bar__price-discounted">${formatMoneyFromCents(discountedCents)}</span>
    `;
    renderStickyEachPrice(eachPriceEl, displayedTotalCents);
    return;
  }

  priceEl.textContent = formatMoneyFromCents(subtotalCents);
  renderStickyEachPrice(eachPriceEl, displayedTotalCents);
}

function renderStickyEachPrice(eachPriceEl, totalCents = getCustomiserTotalCents()) {
  if (!eachPriceEl) return;

  const quantity = getBulkQuantityTotal();

  if (!quantity || quantity < 1 || !totalCents) {
    eachPriceEl.textContent = '';
    eachPriceEl.classList.add('hidden');
    return;
  }

  eachPriceEl.textContent = `(${formatMoneyFromCents(Math.round(totalCents / quantity))} each)`;
  eachPriceEl.classList.remove('hidden');
}

function syncStickyButtonState() {
  const stickyButton = document.querySelector('[data-sticky-add-to-cart]');
  if (!stickyButton || stickyButton.classList.contains('loading')) return;

  stickyButton.disabled = stickyButtonDisabled;
  stickyButton.textContent = stickyButtonText;
  stickyButton.setAttribute('aria-disabled', stickyButtonDisabled ? 'true' : 'false');
}

function updateStickyAddToCartBar() {
  const stickyBar = document.querySelector('[data-sticky-custom-cart-bar]');
  const priceEl = document.querySelector('[data-sticky-total-price]');

  if (stickyBar && stickyBar.parentElement !== document.body) {
    document.body.appendChild(stickyBar);
    document.body.classList.add('has-custom-sticky-cart-bar');
  }

  if (priceEl) {
    renderStickyTotalPrice(priceEl);
  }

  syncStickyButtonState();
  stickyBar?.classList.remove('hidden');
}


document.addEventListener('DOMContentLoaded', function() {
  const grid = document.querySelector('.size-cards-grid');
  const progressFill = document.getElementById('progress-fill');
  const msgContainer = document.querySelector('.next-tier-msg');
  
  if (!grid) return;

  const getDiscountTiers = () => {
    return Array.from(document.querySelectorAll('.tier-mark'))
      .map(mark => {
        const limit = parseInt(mark.dataset.limit, 10);
        const discountText = mark.dataset.discount || mark.querySelector('span')?.textContent || '';
        const discount = parseFloat(discountText.replace(/[^\d.]/g, ''));
        return { limit, discount, element: mark };
      })
      .filter(tier => Number.isFinite(tier.limit) && tier.limit > 0 && Number.isFinite(tier.discount))
      .sort((a, b) => a.limit - b.limit);
  };

  const getTierProgressPercentage = (tiers, quantity) => {
    if (!tiers.length || quantity <= 0) return 0;

    const progressTrack = document.querySelector('.bulk-progress-wrapper .progress-bar-bg');
    const trackRect = progressTrack?.getBoundingClientRect();
    const tierPositions = tiers.map((tier, index) => {
      const tierRect = tier.element?.getBoundingClientRect();

      if (!trackRect?.width || !tierRect?.width) {
        return tiers.length === 1 ? 100 : (index / (tiers.length - 1)) * 100;
      }

      const center = tierRect.left + (tierRect.width / 2);
      return Math.max(0, Math.min(100, ((center - trackRect.left) / trackRect.width) * 100));
    });

    if (quantity <= tiers[0].limit) {
      return (quantity / tiers[0].limit) * tierPositions[0];
    }

    for (let index = 1; index < tiers.length; index += 1) {
      const previousTier = tiers[index - 1];
      const currentTier = tiers[index];

      if (quantity <= currentTier.limit) {
        const tierRange = currentTier.limit - previousTier.limit;
        const tierProgress = tierRange > 0 ? (quantity - previousTier.limit) / tierRange : 1;
        return tierPositions[index - 1] + (tierProgress * (tierPositions[index] - tierPositions[index - 1]));
      }
    }

    return 100;
  };

  const refreshStickyBar = () => {
    window.requestAnimationFrame(updateStickyAddToCartBar);
  };

  new MutationObserver(refreshStickyBar).observe(grid, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['value', 'data-variant-price', 'data-variant-id', 'class']
  });

  grid.addEventListener('input', refreshStickyBar);
  grid.addEventListener('change', refreshStickyBar);
  grid.addEventListener('click', refreshStickyBar);

  // --- 1. CLICK HANDLER (Plus/Minus) ---
  grid.addEventListener('click', function(e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const card = btn.closest('.size-card');
    const input = card.querySelector('.qty-input');
    
    // FIX: Match the attribute name used in your updateSizeCards function
    // If your Liquid uses data-variant-inventory, use dataset.variantInventory
    const stockLimit = parseInt(card.dataset.variantId ? card.querySelector('.stock-count').textContent : 0) || 0;
    
    let currentValue = parseInt(input.value) || 0;

    // Calculate total across all cards
    const allInputs = document.querySelectorAll('.size-card .qty-input');
    const currentGrandTotal = Array.from(allInputs)
                                   .reduce((sum, i) => sum + (parseInt(i.value) || 0), 0);

    if (btn.classList.contains('plus')) {
        if (currentValue < stockLimit) {
            input.value = currentValue + 1;
            card.classList.add('active'); // Visual feedback
        } else {
            if (typeof shakeCard === 'function') shakeCard(card);
        }
    } else if (btn.classList.contains('minus')) {
        // Prevent lowering if it's the last item in the whole set
        if (currentGrandTotal <= 1 && currentValue === 1) {
            if (typeof shakeCard === 'function') shakeCard(card);
            return; 
        }
        
        if (currentValue > 0) {
            input.value = currentValue - 1;
            // If value hits 0, remove active class
            if (input.value == 0) card.classList.remove('active');
        }
    }

    // Ensure this function exists to update your UI totals/price
    if (typeof updateAllTotals === 'function') {
        updateAllTotals();
    }
  });

  // --- 2. INPUT HANDLER (Manual Typing) ---
  grid.addEventListener('input', function(e) {
    if (e.target.classList.contains('qty-input')) {
      const card = e.target.closest('.size-card');
      const stockLimit = parseInt(card.querySelector('.stock-count')?.textContent || card.dataset.inventory || 0);
      let val = parseInt(e.target.value) || 0;

      const otherTotals = Array.from(document.querySelectorAll('.qty-input'))
                               .filter(i => i !== e.target)
                               .reduce((sum, i) => sum + (parseInt(i.value) || 0), 0);

      if (val + otherTotals < 1) {
        e.target.value = 1;
      } else if (val > stockLimit) {
        e.target.value = stockLimit;
      }

      updateAllTotals();
    }
  });

  // --- 3. UI UPDATE LOGIC (Progress Bar & Tiers) ---
  function updateAllTotals() {
    let grandTotal = 0;
    const allInputs = document.querySelectorAll('.qty-input');

    allInputs.forEach(input => {
      const val = parseInt(input.value) || 0;
      grandTotal += val;
      const card = input.closest('.size-card');
      card.classList.toggle('active', val > 0);
    });

    const tiers = getDiscountTiers();
    // Update Progress Bar Width
    if (progressFill) {
      const percentage = getTierProgressPercentage(tiers, grandTotal);
      progressFill.style.width = percentage + '%';
    }

    // Update Discount Message & Tier Highlighting
    if (msgContainer) {
      const currentTier = [...tiers].reverse().find(tier => grandTotal >= tier.limit);
      const nextTier = tiers.find(tier => grandTotal < tier.limit);

      if (nextTier) {
        const itemsNeeded = nextTier.limit - grandTotal;
        msgContainer.classList.remove('is-success');
        msgContainer.innerHTML = `Add <strong>${itemsNeeded}</strong> more for <strong>${nextTier.discount}%</strong> off`;
      } else if (currentTier) {
        msgContainer.classList.add('is-success');
        msgContainer.innerHTML = `Success! Your <strong>${currentTier.discount}%</strong> bulk discount will be applied at checkout.`;
      } else {
        msgContainer.classList.remove('is-success');
        msgContainer.textContent = '';
      }
    }

    // Highlight achieved tier labels
    document.querySelectorAll('.tier-mark').forEach(mark => {
      const limit = parseInt(mark.dataset.limit);
      mark.classList.toggle('achieved', grandTotal >= limit);
    });

    updateButtonState();
  }

  function shakeCard(card) {
    card.classList.add('shake');
    setTimeout(() => card.classList.remove('shake'), 400);
  }

  // Set initial state on page load
  updateAllTotals();
});




function updateSizeCards() {
    const activeColorBtn = document.querySelector('#color-selector-container button.is-active');
    const colorCandidates = getActiveColorCandidates(activeColorBtn);
    const variantItems = [...productVariantListItems];

    document.querySelectorAll('.size-card').forEach(card => {
        const cardSize = card.dataset.size || '';
        const matchingVariantRecord = findVariantRecordForSelection(cardSize, colorCandidates);

        let matchingVariant = variantItems.find(li => {
            const optionValues = getVariantOptionValues(li);
            const titleParts = getVariantTitleParts(li);
            const variantColor = getVariantOptionByConfiguredIndex(li, 'color');
            const variantSize = getVariantOptionByConfiguredIndex(li, 'size');
            const searchableValues = optionValues.length ? optionValues : titleParts;
            const sizeMatches = cardSize ? (
                optionValueMatches(cardSize, [variantSize]) || optionValueMatches(cardSize, searchableValues)
            ) : true;
            const colorMatches = !colorCandidates.length || colorCandidates.some(candidate => (
                optionValueMatches(candidate, [variantColor]) || optionValueMatches(candidate, optionValues) || optionValueMatches(candidate, titleParts)
            ));

            return sizeMatches && colorMatches;
        });

        if (matchingVariantRecord) {
            const recordId = String(matchingVariantRecord.id || '');
            matchingVariant = variantItems.find(li => String(li.dataset.variantId || '') === recordId) || matchingVariant;
        }

        const stockCountEl = card.querySelector('.stock-count');
        const qtyInput = card.querySelector('.qty-input');

        if (matchingVariant || matchingVariantRecord) {
            card.dataset.variantId = matchingVariant?.dataset.variantId || matchingVariantRecord?.id || '';
            card.dataset.variantPrice = matchingVariant?.dataset.variantPrice || matchingVariantRecord?.price || '0';
            card.dataset.variantAvailable = matchingVariantRecord?.available ?? matchingVariant?.dataset.variantAvailable ?? 'false';
            card.dataset.inventoryManagement = matchingVariantRecord?.inventoryManagement || matchingVariant?.dataset.inventoryManagement || '';
            card.dataset.inventoryPolicy = matchingVariantRecord?.inventoryPolicy || matchingVariant?.dataset.inventoryPolicy || '';
            
            const inventory = getResolvedVariantInventory(matchingVariant, matchingVariantRecord, cardSize, colorCandidates);
            
            if (stockCountEl) stockCountEl.textContent = inventory;
            if (qtyInput) qtyInput.max = inventory;

            if (parseInt(inventory) <= 0) {
                card.classList.add('is-out-of-stock');
                qtyInput.value = 0;
            } else {
                card.classList.remove('is-out-of-stock');
                // Ensure there is at least 1 selected if it's the first active card
                if (card.classList.contains('active') && qtyInput.value == 0) {
                    qtyInput.value = 1;
                }
            }
            
            card.style.opacity = "1";
            card.style.pointerEvents = "all";
            card.style.display = ""; 
        } else {
            card.dataset.variantId = '';
            card.dataset.variantPrice = '0';
            card.dataset.variantAvailable = 'false';
            card.dataset.inventoryManagement = '';
            card.dataset.inventoryPolicy = '';
            if (stockCountEl) stockCountEl.textContent = '0';
            if (qtyInput) qtyInput.value = 0;
            card.classList.remove('active');
            card.classList.add('is-out-of-stock');
            card.style.opacity = "1";
            card.style.pointerEvents = "all";
            card.style.display = ""; 
        }
    });

    updateButtonState();
}


document.querySelector('[data-sticky-add-to-cart]')?.addEventListener('click', handleCustomAddToCart);

async function handleCustomAddToCart(e) {
  if (!canAddToCart) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
  e.preventDefault();

  if (!meetsMinimumOrderQuantity()) {
    alert(getMinimumOrderQuantityMessage());
    updateButtonState();
    return false;
  }

  // 1. Visual Feedback (Start loading immediately as image generation/upload takes time)
  const button = e.currentTarget;
  const cartDrawer = document.querySelector('cart-drawer');

  button.innerText = 'Processing images...';
  
  button.disabled = true;
  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');
  updateStickyAddToCartBar();

  const selectedPositions = getSelectedPositions();

  

  try {
    // 2. Generate the merged image
    await new Promise(resolve => setTimeout(resolve, 100));

    const mergedBlob = await getMergedDesignBlob();

    if (!mergedBlob) {
      throw new Error("No design image generated");
    }

    const fileName = `customized-product-${Date.now()}`;
    const cloudinaryUrl = await uploadImageToCloudinary(mergedBlob, fileName, 'jpg');

    button.innerText = "Uploading artwork...";
    const uploadedArtworkUrls = await uploadSelectedArtworkFiles(selectedPositions);

    button.innerText = "Adding to cart...";


    // 4. Build the items array with the new URL
    const items = [];
    const selectedLocationNames = selectedPositions.map(formatSelectedLocation);
    const printLocations = selectedPositions.map(formatPrintLocation);
    const missingAddOnVariant = selectedPositions.find(position => (
      parseMoneyToCents(position.addOnPrice) > 0 && !position.addOnVariantId
    ));

    if (missingAddOnVariant) {
      throw new Error(`The add-on product for ${missingAddOnVariant.positionName} is missing a variant ID.`);
    }

    const customizationMetadata = selectedPositions.map(position => ({
      decorationType: activeDecorationType,
      view: position.view,
      viewName: position.viewName,
      positionId: position.positionId,
      positionName: position.positionName,
      addOnVariantId: position.addOnVariantId,
      addOnTitle: position.addOnTitle,
      addOnPrice: position.addOnPrice,
      cloudinaryUrl,
      uploadedArtworkUrl: uploadedArtworkUrls[position.view]?.url || '',
      uploadedArtworkFileName: uploadedArtworkUrls[position.view]?.fileName || '',
      transform: getCanvasTransform(position.view)
    }));

    const uploadedArtworkProperties = Object.values(uploadedArtworkUrls).map(artwork => ({
      view: artwork.view,
      fileName: artwork.fileName,
      url: artwork.url
    }));

    document.querySelectorAll('.size-card').forEach(card => {
      const qtyInput = card.querySelector('.qty-input');
      const qty = parseInt(qtyInput?.value || 0);
      const variantId = card.dataset.variantId;

      if (qty > 0 && variantId) {
        items.push({
          id: variantId,
          quantity: qty,
          properties: {
            "Decoration Type": activeDecorationType,
            "Print Locations": printLocations.join(', '),
            "Selected Print Locations": selectedLocationNames.join(', '),
            "_Design_Preview": cloudinaryUrl,
            "_Cloudinary_Image_URL": cloudinaryUrl,
            "_Uploaded_Artwork_URLs": JSON.stringify(uploadedArtworkProperties),
            "_Customisation_Metadata": JSON.stringify(customizationMetadata)
          }
        });


        //B. Add every add-on found in your views for this quantity
        selectedPositions.forEach(position => {
          if (!position.addOnVariantId) return;

          items.push({
            id: position.addOnVariantId,
            quantity: qty,
            parent_id: variantId,
            properties: {
              "_Add_on": `${activeDecorationType} - ${position.positionName}`,
              "_Add_on_Price": position.addOnPrice,
              "_Parent_Custom_Product": variantId,
              "_Customisation_View": position.viewName,
              "_Customisation_Position": position.positionName,
              "_Design_Preview": cloudinaryUrl,
              "_Uploaded_Artwork_URL": uploadedArtworkUrls[position.view]?.url || '',
              "_Uploaded_Artwork_File": uploadedArtworkUrls[position.view]?.fileName || ''
            }
          });
        });




      }
    });

    if (items.length === 0) {
      alert("Please select at least one size and quantity.");
      return;
    }

    // 5. Shopify Cart API Call
    const formData = {
      items: items,
      sections: cartDrawer?.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    };

    const cartResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const cartData = await cartResponse.json();

    if (cartData.status === 422) {
      throw new Error(cartData.description);
    }

    // 6. Open the Cart Drawer
    if (cartDrawer) {
      cartDrawer.renderContents(cartData);
      setTimeout(() => {
        cartDrawer.classList.add('animate', 'active');
      }, 50);
      cartDrawer.classList.remove('is-empty');
    }

  } catch (error) {
    console.error('Process Error:', error);
    alert(error.message || "Something went wrong.");
  } finally {
    // 7. Reset Loading State
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    updateButtonState();
  }
}



function updateButtonState() {
  const selectedPositions = getSelectedPositions();
  const hasActivePosition = selectedPositions.length > 0;
  
  const hasUserImage = Object.values(fabricCanvasMap).some(canvas => (
    canvas && canvas.getObjects().some(obj => obj.type === 'image')
  ));

  // --- THE GATEKEEPER LOGIC ---

  if (!hasActivePosition) {
    // STATE 1: Default - No position selected
    canAddToCart = false;
    stickyButtonDisabled = true;
    stickyButtonText = "PLEASE SELECT PRINT AREAS";
  } 
  else if (hasActivePosition && !hasUserImage) {
    // STATE 2: Position selected, but waiting for image
    canAddToCart = false;
    stickyButtonDisabled = true;
    stickyButtonText = "UPLOAD YOUR IMAGE";
  } 
  else if (!meetsMinimumOrderQuantity()) {
    // STATE 3: Customizer is ready, but the selected quantity is below the product minimum
    canAddToCart = false;
    stickyButtonDisabled = true;
    stickyButtonText = `MINIMUM QTY ${getMinimumOrderQuantity()}`;
  }
  else if (hasActivePosition && hasUserImage) {
    // STATE 4: Ready to go
    canAddToCart = true;
    stickyButtonDisabled = false;
    stickyButtonText = "ADD TO CART";
  }

  updateStickyAddToCartBar();
}




/**
 * Captures ALL views (Front, Back, etc.) regardless of design presence.
 * Returns: Array of { name: string, url: string (base64) }
 */
async function getCapturedDesignData() {
  const capturedViews = [];
  const previouslyVisibleView = document.querySelector('.canvas-view:not(.hidden)')?.dataset.view;
  const canvasWasActive = !mainCanvasView.classList.contains('hidden');

  try {
    // We loop through all keys (Front, Back) in your map
    for (const viewName in fabricCanvasMap) {
      if (!canvasHasArtwork(viewName)) continue;

      const viewEl = document.querySelector(`.canvas-view[data-view="${viewName}"]`);
      const yellowBox = viewEl?.querySelector('.canvas-data');
      
      if (viewEl) {
        // --- PREPARE FOR CAPTURE ---
        if (yellowBox) yellowBox.style.opacity = '0';
        
        mainCanvasView.classList.remove('hidden');
        allCanvasParents.forEach(c => c.classList.add('hidden')); 
        viewEl.classList.remove('hidden');

        const screenshot = await html2canvas(viewEl, { 
          useCORS: true, 
          scale: 2,
          backgroundColor: null // Keeps transparency if needed
        });

        // --- RESTORE UI MARKERS ---
        if (yellowBox) yellowBox.style.opacity = '1';

        capturedViews.push({
          name: viewName.toUpperCase(),
          url: screenshot.toDataURL("image/png")
        });
      }
    }
  } catch (err) {
    console.error("Capture Engine Error:", err);
  } finally {
    // --- UI RESTORATION (Guaranteed to run) ---
    if (canvasWasActive && previouslyVisibleView) {
        mainCanvasView.classList.remove('hidden');
        mainProductImage.classList.add('hidden');
        handleCanvasVisibility(previouslyVisibleView);
    } else {
        mainCanvasView.classList.add('hidden');
        mainProductImage.classList.remove('hidden');
    }
  }
  return capturedViews;
}


async function getMergedDesignBlob() {
  const views = await getCapturedDesignData();
  if (views.length === 0) return null;

  const merger = document.createElement("div");

  Object.assign(merger.style, {
    display: "flex",
    gap: "40px",
    padding: "40px",
    background: "white",
    position: "fixed",
    left: "-9999px",
    top: "0",
  });

  views.forEach((v) => {
    const div = document.createElement("div");
    div.style.textAlign = "center";
    div.innerHTML = `
      <img crossorigin="anonymous" src="${v.url}" style="width:500px; border:1px solid #eee;">
      <p style="font-family: sans-serif; font-weight: bold; margin-top: 15px; font-size: 20px;">${v.name}</p>
    `;
    merger.appendChild(div);
  });

  document.body.appendChild(merger);

  try {
    const finalCanvas = await html2canvas(merger, {
      backgroundColor: "#ffffff",
      useCORS: true,
    });

    return await new Promise((resolve) => {
      finalCanvas.toBlob(
        (blob) => resolve(blob),
        "image/jpeg",
        0.8,
      );
    });
  } finally {
    document.body.removeChild(merger);
  }
}


document.addEventListener('DOMContentLoaded', () => {
    initSizeGuideModals();
    refreshColorImages();
    updateSizeCards();
    loadPaginatedVariantListItems();
    loadRemoteVariantInventoryData();
    updateButtonState();
    updateUploaderHeadingVisibility();
    
});
